/**
 * ============================================================================
 * 培训管理模块枚举定义
 * ============================================================================
 */

/** 培训任务状态 */
export enum TrainingTaskStatus {
  /** 草稿 */
  DRAFT = 0,
  /** 已发布 */
  PUBLISHED = 1,
  /** 培训中 */
  IN_PROGRESS = 2,
  /** 已完成 */
  COMPLETED = 3,
  /** 已取消 */
  CANCELLED = 4,
}

/** 培训等级 */
export enum TrainingLevel {
  /** 公司级 */
  COMPANY = 1,
  /** 车间级 */
  WORKSHOP = 2,
  /** 班组级 */
  TEAM = 3,
}

/** 参与者状态 */
export enum ParticipantStatus {
  /** 待确认 */
  PENDING = 0,
  /** 已确认 */
  CONFIRMED = 1,
  /** 培训中 */
  IN_PROGRESS = 2,
  /** 已完成 */
  COMPLETED = 3,
  /** 缺席 */
  ABSENT = 4,
}

/** 到场状态 */
export enum AttendanceStatus {
  /** 未标记 */
  NOT_MARKED = 0,
  /** 签到码签到 */
  SIGN_IN_CODE = 1,
  /** 手动标记到场 */
  MANUAL = 2,
  /** 缺席 */
  ABSENT = 3,
}

/**
 * 培训类型分类
 * 与后端 TrainingType::CATEGORY_* 八值对齐（TR-013：以后端存量数据语义为准）
 */
export enum TrainingTypeCategory {
  /** 法定强制培训 */
  MANDATORY = 'mandatory',
  /** 体系认证培训 */
  CERTIFICATION = 'certification',
  /** 客户特定培训 */
  CUSTOMER = 'customer',
  /** 工艺专项培训 */
  PROCESS = 'process',
  /** 设备操作培训 */
  EQUIPMENT = 'equipment',
  /** 变更管理培训 */
  CHANGE = 'change',
  /** 应急响应培训 */
  EMERGENCY = 'emergency',
  /** 质量工具培训 */
  QUALITY = 'quality',
}

/**
 * 培训照片类型
 * 与后端 TrainingPhoto::TYPE_* 对齐（TR-013）
 */
export enum TrainingPhotoType {
  /** 培训现场 */
  SCENE = 1,
  /** 签到表 */
  SIGN_SHEET = 2,
  /** 其他 */
  OTHER = 3,
}
